/**
 * 建筑信息维护
 */
import React from 'react';
import { Input, Row, Col, Icon, Tooltip, Button } from 'antd';
import PageLayout from '../../ui/PageLayout';
import BuildingEdit from './BuildingEdit';
import http from '../../../axios/http';
import messager from '../../ui/messager';
import { global_data } from '../../ui/auth'

class BuildingIndex extends React.Component {

    columns = [{
        title: '所属市场',
        dataIndex: 'orgName',
        width: '10%',
    }, {
        title: '建筑编码',
        dataIndex: 'buildingCode',
        width: '10%',
    }, {
        title: '建筑名称',
        dataIndex: 'buildingName',
        width: '10%',
    }, {
        title: '地址',
        dataIndex: 'addr',
        width: '10%',
    }, {
        title: '显示顺序',
        dataIndex: 'sequence',
        width: '10%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("BUILDING_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("BUILDING_DELETE")?
                <Tooltip title="删除">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, record)} />
                </Tooltip>
                :""}
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {},
    };


    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    };

    add = () => {
        this.setState({ visible: true });
    }

    update = (info, e) => {
        info["address"] = [info.province, info.city, info.zone];
        this.setState({ editData: info, visible: true });
    }

    delete = (info, e) => {
        messager.confirm("是否删除该建筑？", () => {
            http.post({
                url: '/building/deleteBuilding',
                data: { id: info.id },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("删除成功！");
                }
            });
        });
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.buildingName = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="建筑名称"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: 300, marginRight: '10px' }}
                                />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                            {global_data.authCode.includes("BUILDING_ADD")?
                            <Button type="primary" onClick={this.add}>新增</Button>
                            :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="id" url="/building/findBuildingPage" columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <BuildingEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
            </div>
        )
    }
}

export default BuildingIndex;